import useTheme from "./useTheme";
import { mergeProps } from "solid-js";
export default function useThemeProps(options) {
    const theme = useTheme();
    const set = (v) => v;
    const propDefaults = typeof options.propDefaults === "function"
        ? options.propDefaults({
            set,
            inProps: options.props,
        })
        : options.propDefaults;
    return mergeProps(...[
        ...(propDefaults ? [propDefaults] : []),
        () => theme.components?.[options.name]?.defaultProps || {},
        options.props,
    ]);
}
